import React from 'react';

interface IProps {
  text: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: (e?: any) => void;
  disabled?: boolean;
}
const CustomButton = (props: IProps) => {
  return (
    <>
      <div>
        <button
          className={`custom-button ${props.className || ''}`}
          style={props.style}
          onClick={props.onClick}
          disabled={props.disabled}
        >
          {props.text}
        </button>
      </div>
    </>
  );
};

export default CustomButton;
